import React from 'react';

export default function DynamicFieldCell({ value, column }) {
  if (value === '' || value === null || value === undefined) return <span />;

  let display = value;
  if (typeof value === 'number') {
    const decimals = column.decimal_count || 2;
    display = value.toFixed(decimals);
  }

  return <span>{display}</span>;
}
